import { render, staticRenderFns } from "./BusinessTab.vue?vue&type=template&id=5ea18ba4&scoped=true"
import script from "./BusinessTab.vue?vue&type=script&lang=js"
export * from "./BusinessTab.vue?vue&type=script&lang=js"
import style0 from "./BusinessTab.vue?vue&type=style&index=0&id=5ea18ba4&prod&lang=scss"
import style1 from "./BusinessTab.vue?vue&type=style&index=1&id=5ea18ba4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea18ba4",
  null
  
)

export default component.exports